import { observable } from 'mobx';
import type { Moment } from '@this/src/lib/moment';
import moment from '@this/src/lib/moment';
import type { TripStatusKey } from '../trip/trip_status';

export type MessageBulkSendTodoResponseArgs = {
  todo_type: string;
  trip_id: number;
  trip_status: number;
  category: string;
  organization_name?: string;
  start_date?: string;
  end_date?: string;
  received_at?: string;
  is_urgent: boolean;
  last_user_message?: string;
  last_user_message_id?: number;
};

export type MessageBulkSendTodoArgs = {
  todoType: string;
  tripId: number;
  tripStatus: TripStatusKey;
  category: string;
  organizationName?: string;
  startDate?: Moment;
  endDate?: Moment;
  receivedAt?: Moment;
  isUrgent: boolean;
  lastUserMessage?: string;
  lastUserMessageId?: number;
};

export const convertMessageBulkSendTodoResponseToArgs = (
  response: MessageBulkSendTodoResponseArgs
): MessageBulkSendTodoArgs => {
  return {
    todoType: response.todo_type,
    tripId: response.trip_id,
    tripStatus: response.trip_status as TripStatusKey,
    category: response.category,
    organizationName: response.organization_name,
    startDate: response.start_date ? moment(response.start_date) : undefined,
    endDate: response.end_date ? moment(response.end_date) : undefined,
    receivedAt: response.received_at ? moment(response.received_at) : undefined,
    isUrgent: response.is_urgent,
    lastUserMessage: response.last_user_message,
    lastUserMessageId: response.last_user_message_id
  };
};

export default class MessageBulkSendTodo {
  @observable readonly todoType: string;
  @observable readonly tripId: number;
  @observable readonly tripStatus: TripStatusKey;
  @observable readonly category: string;
  @observable readonly organizationName?: string;
  @observable readonly startDate?: Moment;
  @observable readonly endDate?: Moment;
  @observable readonly receivedAt?: Moment;
  @observable readonly isUrgent: boolean;
  @observable readonly lastUserMessage?: string;
  @observable readonly lastUserMessageId?: number;

  constructor(args: MessageBulkSendTodoArgs) {
    this.todoType = args.todoType;
    this.tripId = args.tripId;
    this.tripStatus = args.tripStatus;
    this.category = args.category;
    this.organizationName = args.organizationName;
    this.startDate = args.startDate;
    this.endDate = args.endDate;
    this.receivedAt = args.receivedAt;
    this.isUrgent = args.isUrgent;
    this.lastUserMessage = args.lastUserMessage;
    this.lastUserMessageId = args.lastUserMessageId;
  }
}
